export default "__VITE_ASSET__7f4b7011__"